import {createSelector} from 'reselect';

const drawerCollapsed = (state) => state.drawerCollapsed;

export const getCollapsed = createSelector(
  [drawerCollapsed],
  (collapsed) => collapsed
);

const viewType = (state) => state.designChapter.currentView.viewType;

export const getViewType = createSelector([viewType], (viewType) => viewType);

const title = (state) => state.designChapter.currentView.title;

export const getTitle = createSelector([title], (title) => title);

const description = (state) => state.designChapter.currentView.description;

export const getDescription = createSelector(
  [description],
  (description) => description
);

const slideTree = (state) => state.designChapter.currentView.slideTree;

export const getSlideTree = createSelector(
  [slideTree],
  (slideTree) => slideTree
);

const totalNodeComponents = (state) =>
  state.designChapter.currentView.totalNodeComponents;
const correctNodeComponents = (state) =>
  state.designChapter.currentView.correctNodeComponents;

export const getHintVisibility = createSelector(
  [totalNodeComponents, correctNodeComponents],
  (totalNodeComponents, correctNodeComponents) => {
    if (totalNodeComponents === correctNodeComponents) return false;
    else return true;
  }
);

const currentChapter = (state) => state.currentChapter;

export const getIsDesignChapter = createSelector(
  [currentChapter],
  (currentChapter) => currentChapter === undefined
);
